const invoiceData = [
    {
        invoiceId: "#VL25000351",
        img: 'assets/images/users/avatar-2.jpg',
        name: "Diana Kohler",
        email: "jamesmorris@velzon.com",
        country: "Germany",
        date: "17 Dec, 2021",
        time: "1:24AM",
        amount: "$875",
        status: "Paid",
        statusClass: "success",
        isSelected: false
    },
    {
        invoiceId: "#VL25000352",
        img: 'assets/images/users/avatar-3.jpg',
        name: "James Morris",
        email: "jamesmorris@velzon.com",
        country: "Germany",
        date: "17 Dec, 2021",
        time: "1:24AM",
        amount: "$451.00",
        status: "Unpaid",
        statusClass: "warning",
        isSelected: false

    },
    {
        invoiceId: "#VL25000353",
        img: 'assets/images/users/avatar-4.jpg',
        name: "Dawn Koh",
        email: "dawnkoh@velzon.com",
        country: "United Kingdom",
        date: "29 Nov, 2021",
        time: "7:20PM",
        amount: "$984.98",
        status: "Paid",
        statusClass: "success",
        isSelected: false

    },
    {
        invoiceId: "#VL25000354",
        img: 'assets/images/users/avatar-5.jpg',
        name: "Tonya Noble",
        email: "tonynoble@velzon.com",
        country: "Spain",
        date: "22 Nov, 2021",
        time: "10:20PM",
        amount: "$742.12",
        status: "Cancel",
        statusClass: "danger",
        isSelected: false

    },
    {
        invoiceId: "#VL25000355",
        img: 'assets/images/users/avatar-6.jpg',
        name: "David Nichols",
        email: "davidnochols@velzon.com",
        country: "United States of America",
        date: "11 Nov, 2021",
        time: "12:37AM",
        amount: "$2415.00",
        status: "Unpaid",
        statusClass: "warning",
        isSelected: false

    },
    {
        invoiceId: "#VL25000356",
        img: 'assets/images/users/avatar-7.jpg',
        name: "Joseph Payten",
        email: "josephpayten@velzon.com",
        country: "France",
        date: "03 Nov, 2021",
        time: "12:29AM",
        amount: "$7451.02",
        status: "Paid",
        statusClass: "success",
        isSelected: false

    },
    {
        invoiceId: "#VL25000357",
        name: "Mary Rucker",
        email: "maryrucker@velzon.com",
        country: "United Kingdom",
        date: "27 Oct, 2021",
        time: "01:46PM",
        amount: "$327.36",
        status: "Cancel",
        statusClass: "danger",
        isSelected: false

    },
    {
        invoiceId: "#VL25000358",
        name: "Alexis Clarke",
        email: "alexisclarke@velzon.com",
        country: "Spain",
        date: "18 Oct, 2021",
        time: "04:55PM",
        amount: "$879.78",
        status: "Unpaid",
        statusClass: "warning",
        isSelected: false
    },
    {
        invoiceId: "#VL25000359",
        img: 'assets/images/users/avatar-8.jpg',
        name: "Ryan Cowie",
        email: "rayancowie@velzon.com",
        country: "France",
        date: "07 Oct, 2021",
        time: "06:33AM",
        amount: "$879.00",
        status: "Refund",
        statusClass: "primary",
        isSelected: false
    },
    {
        invoiceId: "#VL25000360",
        img: 'assets/images/users/avatar-4.jpg',
        name: "Christina Maier",
        email: "christinamaier@velzon.com",
        country: "United States of America",
        date: "13 Sep, 2021",
        time: "11:59AM",
        amount: "$1624.18",
        status: "Unpaid",
        statusClass: "warning",
        isSelected: false
    },
    {
        invoiceId: "#VL25000361",
        img: 'assets/images/users/avatar-2.jpg',
        name: "Jennifer Winkel",
        email: "jenniferwinkal@velzon.com",
        country: "Brazil",
        date: "15 Aug, 2021",
        time: "01:05PM",
        amount: "$214.67",
        status: "Cancel",
        statusClass: "danger",
        isSelected: false
    },
    {
        invoiceId: "#VL25000362",
        name: "Erik Peters",
        email: "erikpeters@velzon.com",
        country: "Mexico",
        date: "07 Aug, 2021",
        time: "07:46PM",
        amount: "$1798.71",
        status: "Paid",
        statusClass: "success",
        isSelected: false
    },
];

export { invoiceData };
